import { Modal } from '@mantine/core'
import PreNoticeForm from '../PreNoticeForm'
import Image from 'next/image'
import { IApplyPreNotice } from 'app/pre-notice/_types'
import { useMemo } from 'react'
import { useParams } from 'next/navigation'
import { XMarkIcon } from '@heroicons/react/20/solid'
const PreNoticeFormModal = ({
  opened,
  onClose,
  subText,
  onSubmit,
}: {
  opened: boolean
  onClose: () => void
  subText: string
  onSubmit: (data: IApplyPreNotice) => void
}) => {
  const params = useParams()
  const schoolId = params.id as string
  const preNoticeCourseId = useMemo(() => {
    if (schoolId) return schoolId.split('-')[1]
  }, [schoolId])
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      lockScroll={true}
      styles={{
        content: {
          width: '540px',
          padding: '60px 24px',
          borderRadius: '20px',
        },
        body: {
          padding: 0,
        },
      }}
      centered
    >
      <div className="w-min-0 mb-8 flex flex-1 flex-col items-center justify-center gap-1">
        <div className="absolute right-5 top-5">
          <button onClick={onClose} type="button">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <Image
          src="https://d35ai18pny966l.cloudfront.net/course/kdt/pre_notice_logo.png"
          alt="멋쟁이사자처럼X고용노동부"
          width={218}
          height={27}
        />
        <p className="text-2xl font-semibold leading-snug">
          <span className="mr-1 inline-block text-primary-normal">멋사 부트캠프</span>
          사전알림 신청
        </p>
        <p className="max-w-full truncate text-sm text-label-neutral">{subText}</p>
      </div>
      <PreNoticeForm onSubmit={onSubmit} defaultValues={preNoticeCourseId}>
        <div className="px-4">
          <button className="mt-8 w-full rounded-md bg-primary py-3 text-lg font-semibold text-white">
            사전알림 신청하기
          </button>
        </div>
      </PreNoticeForm>
    </Modal>
  )
}

export default PreNoticeFormModal
